<!--
@作者 王
@创建于 2021/2/26 15:52
-->

<template>
  <div>
    <lj-list-page
        :noAction="noAction"
        :searchBaseForm="searchBaseForm"
        :tableList="list"
        :searchForms="searchForms"
        :list-loading="listLoading"
        :tableMutiSelect="false"
        :tableSeq="false"
        :tableTotal="tableTotal"
        :table-row-click="noAction || noDetail?()=>{}:showView"
        @tableLoadMethod="getList"
        :headerColumns="headerColumns">
      <template v-slot:topButton>
        <slot name="topButtonItem">
        </slot>
        <slot name="topButton">
          <el-button
              v-if="addApi"
              icon="el-icon-plus"
              plain
              type="primary"
              @click="onAdd"
          >新增
          </el-button>
        </slot>
      </template>
      <template v-slot:action="data">
        <slot name="actionButton" :data="data">

          <el-button
              size='mini'
              type="text"
              @click.stop="showView(data)"
          >查看
          </el-button>
          <el-button
              size='mini'
              type="text"
              v-if="updateApi"
              @click.stop="showEdit(data)"
          >编辑
          </el-button>
          <el-button
              size='mini'
              type="text"
              v-if="deleteApi"
              @click.stop="delData(data)"
          >删除
          </el-button>
        </slot>
      </template>

      <template :slot="data.prop" slot-scope="value" v-for="data in headerColumns">
        <slot :name="data.prop" :data="value">
        </slot>
      </template>
    </lj-list-page>
    <lj-view-dialog ref="viewDialog" :dictionary="dictionary" title="详情">

      <template slot="tableView" slot-scope="data">
        <slot name="tableView" :data="data">
        </slot>
      </template>
    </lj-view-dialog>
    <edit-dialog
        width="80%"
        ref="editDialog"
        @updateList="getList"
        :editFormData="editFormData"
        :dictionary="dictionary"
        :title="editTitle"
        :addApi="addApi"
        :changeSubmit="changeSubmit"
        :changeDetail="changeDetail"
        :updateApi="updateApi"

        :getDetailApi="getDetailApi">
      <template v-for="data in editFormData" :slot="data.name" slot-scope="value">
        <slot :name="data.name" :data="value">
        </slot>
      </template>

    </edit-dialog>
  </div>
</template>

<script>
import editDialog from "./edit";
import {getDepListForOptionApi, getUnitSelectListApi} from "../../../server/system";

export default {
  name: "lj-c-r-u-d",
  components: {editDialog},
  props: {
    // 详情展示字典
    searchBaseForm: {
      type: Object
    },
    noAction: {
      type: Boolean
    },
    noDetail: {
      type: Boolean
    },
    editFormData: {
      type: Array
    },
    changeSubmit: {
      type: Function
    },
    changeDetail: {
      type: Function
    },
    editTitle: {
      type: String,
      default: '编辑'
    },
    updateApi: {
      type: Function
    },
    addApi: {
      type: Function
    },
    getListApi: {
      type: Function
    },
    deleteApi: {
      type: Function
    },
    getDetailApi: {
      type: Function
    },

  },
  data() {
    return {
      list: [],
      listLoading: false,
      tableTotal: 0,
      searchForm: {
        page: '',
        limit: ''
      },

    }
  },
  // mounted() {
  //   this.getMenuTree()
  // },
  computed: {
    searchForms() {
      let arr = this.editFormData.filter(i => i.isSearch);
      return arr
    },


    dictionary() {
      let arr = {};
      this.editFormData.filter(i => !i.notDetail && i.type !== 'line').forEach(i => {
        if (i.type === 'upload') {
          arr[i.name] = {
            label: i.label, // 中文
            prop: i.name,   // key键值
            slot: false,   // 是否插槽模式
            img: true,
            line: false     // 是否整行
          }
        } else if (i.type === 'select') {
          arr[i.name] = {
            label: i.label, // 中文
            prop: i.name,   // key键值
            slot: false,   // 是否插槽模式
            img: false,
            select: true,
            options: i.options,
            line: false     // 是否整行
          }
        }else if (i.type === 'Array'){
          arr[i.name] = {
            prop:i.name, // key键值
            type:'Array'
          }
        } else {
          arr[i.name] = i.label
        }

      });
      return arr
    },
    headerColumns() {
      let arr = [];
      this.editFormData.filter(i => i.isHeader).forEach(i => {
        arr.push({
          name: i.label,
          prop: i.name,
          type: i.headerType
        })
      });
      return arr
    },


  },
  methods: {


    getList(data) {


      this.listLoading = true;
      if (data) {
        this.searchForm = {...data};
        delete this.searchForm.pageNum;
        delete this.searchForm.pageSize;
        this.searchForm.page = data.pageNum;
        this.searchForm.limit = data.pageSize;
      } else {
        this.searchForm.page = 1;
        this.searchForm.limit = 10;
      }

      this.getListApi(this.searchForm).then(res => {
        this.list = res.list;
        this.tableTotal = res.total;
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    showView(data) {
      this.getDetailApi(data.id).then(async res => {
        if (this.changeDetail) {
          res = await this.changeDetail(res);
          this.info = res;

        }

        this.$refs.viewDialog.show(res)
      })

    },
    delData(data) {
      this.$confirm('此操作将永久删除该项', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.deleteApi([data.id]).then(res => {
          this.getList({
            pageNum: 1,
            pageSize: 10
          });
          this.$message({
            message: '删除成功',
            type: 'success'
          });
        })
      });
    },
    async showEdit(data) {
      this.info = data;
      // let res = await this.changeDetail(res);
      this.$refs.editDialog.onShow(data.id);
    },
    onAdd() {
      this.$refs.editDialog.onShow();
    },
    // 获取单位部门
    async setUnitDepSelect(unitKey, depKey) {
      getUnitSelectListApi({permissionName: this.$route.fullPath}).then(res => {
        let arr = [];
        res.forEach(i => {
          arr.push({
            value: i.id,
            label: i.name
          })
        });
        if (unitKey) {
          if (Array.isArray(unitKey)) {
            unitKey.forEach(x => {
              this.editFormData.find(i => i.name === x).options = arr;
              this.editFormData.find(i => i.name === x).value = arr[0].value;
            })
          } else {
            this.editFormData.find(i => i.name === unitKey).options = arr;
            this.editFormData.find(i => i.name === unitKey).value = arr[0].value;
          }
        }
        getDepListForOptionApi({unitId: arr[0].value, permissionName: this.$route.fullPath}).then(res => {
          let arr2 = [];
          res.forEach(i => {
            arr2.push({
              value: i.id,
              label: i.name
            })
          });
          if (depKey) {
            if (Array.isArray(depKey)) {
              depKey.forEach(x => {

                this.editFormData.find(i => i.name === x).options = arr2;
              })
            } else {
              this.editFormData.find(i => i.name === depKey).options = arr2;
            }
          }
          this.editFormData.find(i => i.name === depKey).options = arr2;
          return {unitList: arr, depList: arr2}
        })
      });
    },
    // 设置修改项options
    setEditOptions(api, key, option, objs) {
      if (typeof api === 'function') {
        let limit = -1;
        api({limit: limit,}).then(res => {
          let arr = [];
          if (res.list) {
            res.list.forEach(i => {
              arr.push({
                label: option && option.label ? i[option.label] : i.name,
                value: option && option.value ? i[option.value] : i.id
              })
            });
          } else {
            res.forEach(i => {
              arr.push({
                label: option && option.label ? i[option.label] : i.name,
                value: option && option.value ? i[option.value] : i.id
              })
            });
          }

          if (objs && objs.length > 1) {
            objs.forEach(i => {
              if (typeof key === 'string') {
                this[i].find(i => i.name === key).options = arr;
              } else {
                key.forEach(k => {
                  this[i].find(i => i.name === k).options = arr;
                })
              }

            })
          } else {
            if (typeof key === 'string') {
              this.editFormData.find(i => i.name === key).options = arr;
            } else {
              key.forEach(k => {
                this.editFormData.find(i => i.name === k).options = arr;
              })
            }
          }
          this.$forceUpdate()
        })
      } else {
        let arr = [];
        api.forEach(i => {
          arr.push({
            label: option && option.label ? i[option.label] : i.name,
            value: option && option.value ? i[option.value] : i.id
          })
        });
        if (objs && objs.length > 1) {
          objs.forEach(i => {
            if (typeof key === 'string') {
              this[i].find(i => i.name === key).options = arr;
            } else {
              key.forEach(k => {
                this[i].find(i => i.name === k).options = arr;
              })
            }
          })
        } else {
          if (typeof key === 'string') {
            this.editFormData.find(i => i.name === key).options = arr;
          } else {
            key.forEach(k => {
              this.editFormData.find(i => i.name === k).options = arr;
            })
          }
        }
      }
    },
  },
}
</script>
